import { render, staticRenderFns } from "./pushbtn.vue?vue&type=template&id=4e3dc553&scoped=true"
import script from "./pushbtn.vue?vue&type=script&lang=js"
export * from "./pushbtn.vue?vue&type=script&lang=js"
import style0 from "./pushbtn.vue?vue&type=style&index=0&id=4e3dc553&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3dc553",
  null
  
)

export default component.exports